import I18next from '../../../i18n';

export const getEvidenceButtonLabel = (source?: string, status?: string) => {
  if (!source || !status) {
    return I18next.t('public.PublicReportCard.addEvidence');
  }
  const isVaultTalk = source === 'vault-talk';
  const caseIsNotClosed = status !== 'CLOSED';

  if (caseIsNotClosed) {
    if (isVaultTalk) {
      return I18next.t('public.PublicReportCard.vaultTalkOpenCaseCTA');
    }
    return I18next.t('public.PublicReportCard.addEvidence');
  } else {
    if (isVaultTalk) {
      return I18next.t('public.PublicReportCard.vaultTalkClosedCaseCTA');
    }
    return I18next.t('public.PublicReportCard.viewAdditionalEvidence');
  }
};
